import React from 'react';
import { cn } from '@/lib/utils';

interface BadgeProps {
  children?: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'custom';
  size?: 'sm' | 'md' | 'lg';
  color?: string;
  className?: string;
}

export default function Badge({ 
  children, 
  variant = 'primary', 
  size = 'md',
  color,
  className = '' 
}: BadgeProps) {
  const baseClasses = 'inline-flex items-center font-medium rounded-full transition-colors';
  
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-1.5 text-base'
  };
  
  const variantClasses = {
    primary: 'bg-site-accent/10 text-site-accent border border-site-accent/50',
    secondary: 'bg-site-raised/50 text-site-secondary border border-site-border-control/50',
    success: 'bg-site-success/10 text-site-success border border-site-success/50',
    warning: 'bg-site-warning/10 text-site-warning border border-site-warning/50',
    danger: 'bg-site-danger/10 text-site-danger border border-site-danger/50',
    custom: 'text-site-text border border-site-border'
  };
  
  const customStyle = variant === 'custom' && color ? {
    backgroundColor: `${color}20`,
    borderColor: `${color}40`,
    color: color
  } : {};
  
  return (
    <span 
      className={cn(baseClasses, sizeClasses[size], variantClasses[variant], className)}
      style={customStyle}
    >
      {children}
    </span>
  );
}
